import React from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "@/redux/store";

import whatsappIcon from "@/images/icons/whatsapp.svg";

import "./style.scss";

const NeedHelpWhatsapp = () => {
  const whatsappLink = useAppSelector(
    state => state.common?.configSettings?.staticAssets?.watsappUrlSlug
  );
  const { t } = useTranslation("productDetails");

  if (!whatsappLink) return null;
  return (
    <div className="need-help-whatsapp-block">
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
        <img src={whatsappIcon} alt="WhatsApp" />
        <span>{t("needHelpWhatsapp")}</span>
      </a>
    </div>
  );
};

export default NeedHelpWhatsapp;
